/* eslint-disable no-console */
import {Router} from '@angular/router';
import {isIdentifiableWithId} from './type-guards';
import {environment} from '@environment';
import {hasOwn} from './utils';

/*
 * Dafür gedacht, dass die Daten der geklickten Zeile gleich mitgeschickt werden zur Detailansicht,
 * damit nicht jedes mal ein backend request verschickt wird.
 * Transfer der Daten aktuell nicht möglich wegen dem Aufbau der routen und dem zusammenspiel mit dem splitter.
 *
 * Aktuell funktioniert also nur die Prüfung der id und die navigation
 *
 * TODO: routen und splitter überarbeiten
 */

/**
 * Navigiert zur Detailansicht, wenn die Daten eine 'id' enthalten.
 * @param {Router} router - Angular Router
 * @param {string} basePath - base path der Komponente, z.B. 'people'.
 * @param {T} entity - Daten die mit der Route mitgeschickt werden.
 *                      Wenn diese eine `id` enthalten, wird zur Detailansicht navigiert.
 */
export function navigateToDetailsIfIdentifiable<T>(router: Router, basePath: string, entity: T): void {
    let logsEnabled = false;

    if (
        hasOwn(environment, 'enableNavigationLogs') &&
        typeof environment.enableNavigationLogs !== 'undefined'
    ) {
        logsEnabled = environment.enableNavigationLogs;
    }

    if (logsEnabled) {
        console.log('Entität: ', entity);
    }

    if (isIdentifiableWithId(entity)) {
        // Sicherstellen, dass basePath kein führendes Slash enthält, um absolute Navigation zu vermeiden
        const normalizedBasePath = basePath.startsWith('/') ? basePath.slice(1) : basePath;

        /*
         * Navigation unter Verwendung separater Pfadsegmente
         * Beispiel: ['people', '123']
         */
        const navigationPath = [normalizedBasePath, entity.id];

        // Übergabe der Daten über den router state
        const navigationExtras = {state: {entity}};

        // Navigation ausführen und ggf. loggen
        router.navigate(navigationPath, navigationExtras)
            .then((success) => {
                if (success && logsEnabled) {
                    console.log(`Navigiert zu ${navigationPath.join('/')}`, navigationExtras);
                } else if (!success && logsEnabled) {
                    console.error('Navigation fehlgeschlagen! - ' + navigationPath.join('/'));
                }
            })
            .catch((err) => {
                console.error('Navigationsfehler:', err);
            });
    } else if (logsEnabled) {
        console.warn('Daten sind nicht identifizierbar oder die ID fehlt:', entity);
    }
}
